import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { NavController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {


  constructor(
    public navCtrl: NavController,
    public afAuth: AngularFireAuth,
    public toastController:ToastController,
    public translate:TranslateService
  )
  {

  }

  async presentToast(text) {
    const toast = await this.toastController.create({
      message: text,
      duration: 3000,
      color: 'red'
    });
    toast.present();
  }



  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return new Promise((resolve, reject) => {
        this.afAuth.auth.onAuthStateChanged((user: firebase.User) => {
          if (user ) {
            resolve(true);
          }
         else{
            setTimeout(() => {
              this.navCtrl.navigateBack('/login'); 
            }, 500);
            resolve(false);
          }
        });
      });}
  
}
